import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'formiojs/dist/formio.full.min.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { Toaster } from 'react-hot-toast';
import './setupApiClientSource.js';

(function migrateSessionTokenToLocalStorage() {
  if (typeof window === "undefined" || !window.localStorage || !window.sessionStorage) return;
  try {
    const fromSession = window.sessionStorage.getItem("token");
    if (!fromSession) return;
    if (!window.localStorage.getItem("token")) {
      window.localStorage.setItem("token", fromSession);
    }
    window.sessionStorage.removeItem("token");
  } catch {}
})();

(function patchAdminClientSourceHeader() {
  const rawBase = process.env.REACT_APP_API_URL || "";
  const apiBase = rawBase.replace(/\/$/, "");
  if (!apiBase) return;
  const originalFetch = window.fetch.bind(window);
  window.fetch = function patchedFetch(input, init) {
    let url = "";
    if (typeof input === "string") url = input;
    else if (input && typeof input.url === "string") url = input.url;
    const shouldTag = Boolean(url && url.startsWith(apiBase));
    if (!shouldTag) return originalFetch(input, init);

    const isSharepointUpload = url.includes("/api/sharepoint/upload");
    const token =
      typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;

    if (input instanceof Request) {
      const headers = new Headers(input.headers);
      if (!headers.has("X-Client-Source")) {
        headers.set("X-Client-Source", "web");
      }
      if (isSharepointUpload && token && !headers.has("Authorization")) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      const nextRequest = new Request(input, { headers });
      return originalFetch(nextRequest, init);
    }

    const nextInit = init ? { ...init } : {};
    const headers = new Headers(init?.headers || {});
    if (!headers.has("X-Client-Source")) {
      headers.set("X-Client-Source", "web");
    }
    if (isSharepointUpload && token && !headers.has("Authorization")) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    nextInit.headers = headers;
    return originalFetch(input, nextInit);
  };
})();

// Set Ace Editor worker path to local /ace folder in public
function setAceWorkerPath() {
  const workerPath = (process.env.PUBLIC_URL || '') + '/ace/worker-json.js';
  if (window.ace && window.ace.config) {
    if (window.ace.config.setModuleUrl) {
      window.ace.config.setModuleUrl('ace/mode/json_worker', workerPath);
    }
    if (window.ace.config.set) {
      window.ace.config.set('workerPath', (process.env.PUBLIC_URL || '') + '/ace');
      window.ace.config.set('basePath', (process.env.PUBLIC_URL || '') + '/ace');
    }
  }
}

function setFormioAceWorkerPath() {
  if (
    window.Formio &&
    window.Formio.editors &&
    window.Formio.editors.ace &&
    window.Formio.editors.ace.prototype
  ) {
    window.Formio.editors.ace.prototype.setWorkerPath = setAceWorkerPath;
    window.Formio.editors.ace.prototype.setWorkerPath();
    if (window.Formio.editors.ace.prototype.aceConfig) {
      window.Formio.editors.ace.prototype.aceConfig.workerPath = (process.env.PUBLIC_URL || '') + '/ace';
      window.Formio.editors.ace.prototype.aceConfig.basePath = (process.env.PUBLIC_URL || '') + '/ace';
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  setAceWorkerPath();
  setFormioAceWorkerPath();
});

setAceWorkerPath();
setFormioAceWorkerPath();

// Suppress Ace worker import error globally
window.addEventListener('error', function (e) {
  if (e.message && e.message.includes("Failed to execute 'importScripts'")) {
    e.preventDefault();
    return false;
  }
});

window.addEventListener('unhandledrejection', function (e) {
  console.error('[unhandledrejection]', e.reason);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
    <Toaster />
  </React.StrictMode>
);
